module.exports = __webpack_public_path__ + "media/application/images/icons/twitter-8494b76f97b1ae6fd6eac49496fe78ee.svg";